import { Component, OnInit } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { ClientMerchantsService } from 'src/app/services/apiclient/clientmerchants/clientmerchants.service';
import { Router } from '@angular/router';
import { ToolsService } from 'src/app/services/tools/tools.service';
import {CssService} from "../../../services/css-service";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  clientMerchants$: any[]|any;

  respCols: number = this.media.isActive("xl") ? 3 : (this.media.isActive("xs") || this.media.isActive("md") ? 1 : 2);

  loader: boolean = true;
  searchMerchants:any;


  constructor(
    private media: MediaObserver,
    private clientMerchantApi: ClientMerchantsService,
    private router: Router,
    public cssService: CssService,
    private tools: ToolsService
  ) {
    this.media.asObservable().subscribe((media:any) => {
      this.respCols = (media.mqAlias === "xs" || media.mqAlias === "md") ? 1 : 2;
    });
  }

  ngOnInit() {

    this.tools.setPageClient("dashboard");

    this.clientMerchantApi.getClientMerchants().subscribe(merchants => {

      if (merchants.length === 1) {
        this.goUserOptions(merchants[0]);
      }

      this.clientMerchants$ = merchants;
      this.loader = false;



    });

  }

  goRecharge(merchant: any): void {
    this.router.navigate(["/home/recharge" + "/" + merchant.id_user]);
  }

  goUserOptions(merchant: any): void {

    // if (merchant.options && merchant.options.length > 0) {
    this.router.navigate(["/home/merchantOptions" + "/" + merchant.id_user]);
    // }
  }

  checkMerchantOptions(merchant: any, optionId: number) {
    // 14: Order 15: Cashless
    return merchant.options.includes(optionId) ? true : false;
  }

}
